import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import Filters from './Filters'
import ComponentSlider from "src/mtska-frontend-app-component/components/Slider/ComponentSlider";
import { Button } from 'src/mtska-frontend-app-component';
import { useSettingContextInComponent, useSyncDashboardFullscreenClass } from "src/mtska-frontend-app-scaffolding";
import {
    buildDashboardReportSourceBudget,
    buildDashboardReportListing,
    buildDashboardReportProposal,
    buildDashboardReportAdvertisingCost,
    buildDashboardReportLead,
    DATA_PROVIDER_SOURCE,
    DATA_PROVIDER_LISTING,
    DATA_PROVIDER_PROPOSAL,
    DATA_PROVIDER_ADVERTISING_COST,
    DATA_PROVIDER_LEAD,
} from 'src/mtska-frontend-modules/utils/dashboardSliderReports';

const KEY_PREFIX = 'biint';

const Container = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    useSyncDashboardFullscreenClass();
    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const showFilters = true;
    const showKPI = true;

    const mergedFilters = filterModel ?? defaultFilters;

    const reportSource = buildDashboardReportSourceBudget(t, DATA_PROVIDER_SOURCE, mergedFilters, KEY_PREFIX);
    const reportListing = buildDashboardReportListing(t, DATA_PROVIDER_LISTING, mergedFilters, KEY_PREFIX);
    const reportProposal = buildDashboardReportProposal(t, DATA_PROVIDER_PROPOSAL, mergedFilters, KEY_PREFIX);
    const reportAdvertisingCost = buildDashboardReportAdvertisingCost(t, DATA_PROVIDER_ADVERTISING_COST, mergedFilters, KEY_PREFIX);
    const reportLead = buildDashboardReportLead(t, DATA_PROVIDER_LEAD, mergedFilters, {
        structure: 'biIntegrated',
        keyPrefix: KEY_PREFIX,
    });

    const report = [
        ...reportLead,
        ...reportProposal,
        ...reportListing,
        ...reportAdvertisingCost,
        ...reportSource,
    ];

    return (
        <Box className="mtska-dashboard-container" sx={{ position: "relative" }}>
            {(showKPI || showFilters) &&
                <Box className="dashboard-section-title" sx={{ marginTop: '30px', marginBottom: '10px' }}>
                    <h2>{t('Business Intelligence')}</h2>
                </Box>
            }

            {showFilters &&
                <Filters dataProviderName={dataProviderName} filters={filterModel ?? defaultFilters} />
            }

            <ComponentSlider report={report} />

            <Box className="mtska-fullscreen-toggle">
                <Button
                    variant="soft"
                    size="sm"
                    icon="faExpand"
                    onClick={() => {
                        const parent = document.querySelector('.mtska-dashboard-container');
                        if (!parent) return;
                        if (document.fullscreenElement || document.webkitFullscreenElement) {
                            parent.classList.remove('mtska-fullscreen');
                            if (document.exitFullscreen) {
                                document.exitFullscreen();
                            } else if (document.webkitExitFullscreen) {
                                document.webkitExitFullscreen();
                            }
                        } else {
                            if (parent.requestFullscreen) {
                                parent.requestFullscreen()
                                    .then(() => parent.classList.add('mtska-fullscreen'))
                                    .catch(() => parent.classList.remove('mtska-fullscreen'));
                            } else if (parent.webkitRequestFullscreen) {
                                parent.webkitRequestFullscreen();
                                parent.classList.add('mtska-fullscreen');
                            }
                        }
                    }}
                    aria-label={t('Fullscreen')}
                />
            </Box>
        </Box>
    )
}

export default Container;
